import { FromJSONable } from "./FromJSONable";
import { PassengerType } from "./passengertype";
import {environment} from "../../environments/environment";
import { Trip } from "./trip";
import { TrainStop } from "./trainstop";

export class AvailabilityQuery implements FromJSONable{
    parseJSONObject(object: Object) {
        if(!object){return;}
        Object.assign(this,object);
    }
    id_route:number;
    trips:Trip[] = [];
    passengers:PassengerType[]=[];
    round:boolean=false;
    id_class:number;
    a:number=0;
    m:number=0;
    i:number=0;
    am:number=0;
    startStr:string ="";


    public getForParams():object{
        let s:string;
        var travels:string[]=[];

        this.trips.forEach(e => {
            let src : any = e.id_src;
            let dst : any = e.id_dst;
            let startStr : any = e.startStr;
            if (e.startStr == null) {
                e.startStr = "2020-01-01";
            }
            s = src.id + ',' + dst.id + ',' + startStr;
         
            travels.push(s);
        });

        return {
            'a':this.a,
            'm':this.m,
            'i':this.i,
            'am':this.am,
            'trips':travels.join("~"),
            'class':this.id_class
          };
    }
    getPTsIds():number[]{
        var a : number[] = [];
        for(var i=0;i<this.passengers.length;i++){
            let pt:PassengerType = this.passengers[i];
            a.push(pt.id);
        }
        return a;
    }
}